module.exports = __webpack_public_path__ + "static/media/meters_sml.d018c78e.jpg";